import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/list';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { Store } from '@ngrx/store';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectStoryTemplates } from '@src/suite/common/store/records/records.selectors';

import { LoaderComponent } from '../../../loader/loader';
import { StTextAreaOverlayComponent } from '../../controls/st-text-area/text-area-overlay/st-text-area-overlay';

@Component({
    selector: 'st-select-story-template',
    imports: [CdkOverlayOrigin, LoaderComponent, MatButton, MatDivider, MatRadioButton, MatRadioGroup, StTextAreaOverlayComponent],
    templateUrl: './select-story-template.html',
    styleUrl: './select-story-template.scss',
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-select-story-template',
    },
})
export class SelectStoryTemplateComponent {
    dialogRef = inject<MatDialogRef<SelectStoryTemplateComponent>>(MatDialogRef);
    data = inject<{
        title: string;
    }>(MAT_DIALOG_DATA);

    store = inject(Store);
    globalTablesService = inject(GlobalTablesService);

    public viewStateTypes = ViewStateTypes;
    public selectedStoryTemplate: StorytellingStoryRecord;
    public loading = false;

    languageSettings = this.store.selectSignal(selectI18N)();
    storyTemplates = this.store.selectSignal(selectStoryTemplates);

    updateTitle(event: any) {
        this.data.title = event;
    }

    selectStoryTemplate(event: any) {
        this.selectedStoryTemplate = event;
    }

    save() {
        this.dialogRef.close({ title: this.data.title, template: this.selectedStoryTemplate });
    }

    cancel() {
        this.dialogRef.close();
    }
}
